import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import StyledOutlinedTextField from "../../styledComponents/OutlinedTextField";
import { useAxios } from "../../utils/useAxios";
import { UserContext } from "../../utils/UserContext";
import { useTranslation } from "react-i18next";

const MobilBoxDialog = () => {
    const theme = useTheme();
    const belowsm = useMediaQuery(theme.breakpoints.down("sm"));

    const [open, setOpen] = useState(false);

    const { user, setUser } = useContext(UserContext);

    const axiosInstance = useAxios();

    const { t } = useTranslation();

    useEffect(() => {
        if (user.userID !== undefined) {
            if ( user.roboter === true) {
                if (user.mobilboxPassword === undefined)  {
                    setOpen(true);
                } else {
                    setOpen(false);
                }
            } else {
                setOpen(false);
            }  
            
        }
    }, [user, belowsm])

    const savePassword = (password) => {
        axiosInstance.current({
            url: `/mobilboxpassword/${password}`,
            method: "POST"
        }).then(res => {
            if (res.status === 200) {
                setUser({ ...user, mobilboxPassword: res.data })
                setOpen(false);
            }
        })
    }

    const MobileDialog = () => {

        const [password, setPassword] = useState("");

        return (
            <Dialog
                open={open}
                fullWidth
                maxWidth="xs"
                sx={{
                    "& .MuiDialog-paper": {
                        backgroundImage: "none"
                    }
                }}
            >
                <DialogTitle sx={{ borderBottom: 1, borderColor: "divider", display: "flex", justifyContent: "center" }}>
                    <Typography color="text.primary">{t("voicemail-password-not-set")}</Typography>
                </DialogTitle>
                <DialogContent sx={{ display: "flex", justifyContent: "center" }}>
                    <StyledOutlinedTextField
                        variant="outlined"
                        label={t("voicemail-password")}
                        type="text"
                        value={password}
                        onChange={(event) => { setPassword(event.target.value) }}
                        InputLabelProps={{ shrink: true }}
                        sx={{ mt: 3, width: "80%" }}
                    />
                </DialogContent>
                <DialogActions sx={{ borderTop: 1, borderColor: "divider" }}>
                    <Button onClick={() => { savePassword(password) }} disabled={password === ""} sx={{ color: "text.secondary", textTransform: "none", borderRadius: "16px", "&:hover": { color: "text.primary" }, "&:disabled": { color: "action.disabled" } }}>{t("save")}</Button>
                </DialogActions>
            </Dialog>
        )
    };

    const DesktopDialog = () => {

        const [password, setPassword] = useState("");

        return (
            <Dialog
                open={open}
                fullWidth
                maxWidth="sm"
                sx={{
                    "& .MuiDialog-paper": {
                        backgroundImage: "none"
                    }
                }}
            >
                <DialogTitle sx={{ borderBottom: 1, borderColor: "divider", display: "flex", justifyContent: "center" }}>
                    <Typography color="text.primary">{t("missing-voicemail-password")}</Typography>
                </DialogTitle>
                <DialogContent>
                    <Grid container direction="row">
                        <Grid item>
                            <Typography color="text.secondary" sx={{ mt: 1 }}>{t("missing-voicemail-password-info")}</Typography>
                        </Grid>
                        <Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }}>
                            <StyledOutlinedTextField
                                variant="outlined"
                                label="Mobilboxpasswort"
                                type="text"
                                value={password}
                                onChange={(event) => { setPassword(event.target.value) }}
                                InputLabelProps={{ shrink: true }}
                                sx={{ display: "flex", justifyContent: "center", width: "80%", mt: 3 }}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions sx={{ borderTop: 1, borderColor: "divider" }}>
                    <Button onClick={() => { savePassword(password) }} disabled={password === ""} sx={{ color: "text.secondary", textTransform: "none", borderRadius: "16px", "&:hover": { color: "text.primary" }, "&:disabled": { color: "action.disabled" } }}>{t("save")}</Button>
                </DialogActions>
            </Dialog>
        )
    }

    return belowsm ? <MobileDialog /> : <DesktopDialog />
};

export default MobilBoxDialog;